import courseScheduleService from '../../services/courseScheduleService';

const state = {
  schedules: []
};

const getters = {
  allCourseSchedules: state => state.schedules
};

const actions = {
  async fetchSchedules({ commit }, filters = {}) {
    try {
      const response = await courseScheduleService.getSchedules(filters);
      commit('setSchedules', response.data.data);
    } catch (error) {
      console.error('Store error:', error);
      commit('setSchedules', []);
    }
  },

  async addSchedule({ commit }, scheduleData) {
    const response = await courseScheduleService.addSchedule(scheduleData);
    commit('newSchedule', response.data);
  },

  async updateSchedule({ commit }, scheduleData) {
    const { id, ...data } = scheduleData;
    const response = await courseScheduleService.updateSchedule(id, data);
    commit('updateSchedule', response.data);
  },

  async deleteSchedule({ commit }, scheduleId) {
    await courseScheduleService.deleteSchedule(scheduleId);
    commit('removeSchedule', scheduleId);
  }
};

const mutations = {
  setSchedules: (state, schedules) => {
    state.schedules = schedules || [];
  },
  newSchedule: (state, scheduleData) => state.schedules.push(scheduleData),
  updateSchedule: (state, updatedSchedule) => {
    const index = state.schedules.findIndex(schedule => schedule.id === updatedSchedule.id);
    if (index !== -1) {
      state.schedules.splice(index, 1, updatedSchedule);
    }
  },
  removeSchedule: (state, scheduleId) => {
    state.schedules = state.schedules.filter(schedule => schedule.id !== scheduleId);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 